module.exports = __webpack_public_path__ + "static/sigma-logo-3e5e99057cccb731cf36237102a30417.png";